exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.title[data-v-bb4b903e] {\n    margin: 0 20px;\n}\n}\n", ""]);

